import { DashboardOutlined, SearchOutlined, AppstoreAddOutlined, UnorderedListOutlined, CheckSquareOutlined, TeamOutlined, VideoCameraOutlined, PictureOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';


export const menuConfig = {
    'about':[
        {
            key: 'dashboard',
            label: <Link to="/store/about/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'search_product',
            label: <Link to="/store/about/search_product">Search Product</Link>,
            icon: <SearchOutlined />
        },
        {
            key: 'about_history',
            label: <Link to="/store/about/about_history">History</Link>,
            icon: <UnorderedListOutlined />
        },
        {
            key: 'fbo_orders',
            label: <Link to="/store/about/fbo_orders">FBO Orders</Link>,
            icon: <AppstoreAddOutlined />
        },
        {
            key: 'shelf_labels',
            label: <Link to="/store/about/shelf_labels">Shelf Labels</Link>,
            icon: <CheckSquareOutlined />
        },
    ],
    'outdoor':[
        {
            key: 'dashboard',
            label: <Link to="/store/outdoor/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'search_product',
            label: <Link to="/store/outdoor/search_product">Search Product</Link>,
            icon: <SearchOutlined />
        },
        {
            key: 'outdoor_history',
            label: <Link to="/store/outdoor/outdoor_history">History</Link>,
            icon: <UnorderedListOutlined />
        }
    ],
    'exchange':[
        {
            key: 'dashboard',
            label: <Link to="/store/exchange/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'exchange_processing',
            label: <Link to="/store/exchange/exchange_processing">Exchange Processing</Link>,
            icon: <CheckSquareOutlined />
        },
        {
            key: 'exchange_history',
            label: <Link to="/store/exchange/exchange_history">History</Link>,
            icon: <UnorderedListOutlined />
        },
        // {
        //     key: 'pending_pickup',
        //     label: <Link to="/store/exchange/pending_pickup">Pending Pickups</Link>,
        //     icon: <DashboardOutlined />
        // },
    ],
    
    'mining':[
        {
            key: 'dashboard',
            label: <Link to="/store/mining/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'mining_lead',
            label: <Link to="/store/mining/mining_lead">Mining Leads</Link>,
            icon: <UnorderedListOutlined />
        },
        // {
        //     key: 'push_lead',
        //     label: <Link to="/store/mining/push_lead">Push Leads</Link>,
        //     icon: <UnorderedListOutlined />
        // }
    ],

    'ranking':[
        {
            key: 'dashboard',
            label: <Link to="/store/ranking/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        }
    ],

    'marketing': [
        {
            key: 'dashboard',
            label: <Link to="/store/marketing/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'campaign-gallery',
            label: <Link to="/store/marketing/campaign-gallery">Campaign Gallery</Link>,
            icon: <PictureOutlined />
        },
    ],

    'spl':[
        {
            key: 'dashboard',
            label: <Link to="/store/spl/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'employees-bucket',
            label: <Link to="/store/spl/employees-bucket">Employees Bucket</Link>,
            icon: <TeamOutlined />
        },
    ],
    
    'manager':[
        {
            key: 'dashboard',
            label: <Link to="/store/manager/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'create_discount',
            label: <Link to="/store/manager/create_discount">Discount</Link>,
            icon: <AppstoreAddOutlined />
        },
        {
            key: 'discount_history',
            label: <Link to="/store/manager/discount_history">History</Link>,
            icon: <UnorderedListOutlined />
        },
        {
            key: 'check_discount',
            label: <Link to="/store/manager/check_discount">Check Discount</Link>,
            icon: <CheckSquareOutlined />
        },
    ],
    'vas':[
        {
            key: 'dashboard',
            label: <Link to="/store/vas/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        }
    ],

    'auto_billing':[
        {
            key: 'dashboard',
            label: <Link to="/store/auto_billing/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'billing',
            label: <Link to="/store/auto_billing/billing">Auto Billing</Link>,
            icon: <CheckSquareOutlined />
        },
        {
            key: 'history',
            label: <Link to="/store/auto_billing/history">History</Link>,
            icon: <UnorderedListOutlined />
        }
    ],
    
    'finance':[
        {
            key: 'dashboard',
            label: <Link to="/store/finance/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'finance_processing',
            label: <Link to="/store/finance/finance_processing">Finance Processing</Link>,
            icon: <CheckSquareOutlined />
        },
        {
            key: 'finance_history',
            label: <Link to="/store/finance/finance_history">History</Link>,
            icon: <UnorderedListOutlined />
        },
    ],

    'review_offer':[
        {
            key: 'dashboard',
            label: <Link to="/store/review_offer/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'generate-coupon',
            label: <Link to="/store/review_offer/generate-coupon">Generate Coupon</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'review_offer_history',
            label: <Link to="/store/review_offer/review_offer_history">History</Link>,
            icon: <UnorderedListOutlined />
        },
    ],

    'meeting':[
        {
            key: 'dashboard',
            label: <Link to="/store/meeting/dashboard">Dashboard</Link>,
            icon: <VideoCameraOutlined />
        },
    ]

};
